import { Fragment } from "react"
import { useFormContext } from "react-hook-form"
import { CircularProgress } from "@mui/material"
import AddressTableRows from "./AddressTableRows"

function AddressTable({isAdding, deleteTableRow, addTableRow}) {
  const { formState: { isSubmitting } } = useFormContext();
  return (
    <Fragment>
      <AddressTableRows isAdding={isAdding} deleteTableRow={deleteTableRow}/>
      <tr>
        <td className="text-end" colSpan={8} bgcolor="white">
          {!isAdding ? (
            <button type="button" className="btn btn-primary" onClick={addTableRow}>+ Add Address</button>
          ) : (
            <button type="submit" className="btn btn-success" disabled={isSubmitting}>
              {isSubmitting
                ? <><CircularProgress size={16} color="inherit" style={{ marginRight: 6 }} />Saving...</>
                : 'Save Addresses'}
            </button>
          )}
        </td>
      </tr>
    </Fragment>
  );
}

export default AddressTable;
